exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".p-amount{font-size:1.3em;font-weight:700}.p-timer{font-size:1.2em;font-weight:700;color:tomato}.copy2clipboard{cursor:pointer}.p-toast{position:absolute;margin-top:-30px;margin-left:-30px;border-radius:4px;background-color:#333;padding:4px;color:#fff;font-size:.8em}", ""]);

// exports
